var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMenu02Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_13083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12ZM12 7.5C12.83 7.5 13.5 8.17 13.5 9C13.5 9.83 12.83 10.5 12 10.5C11.17 10.5 10.5 9.83 10.5 9C10.5 8.17 11.17 7.5 12 7.5ZM18.5 9.87L17.96 9.69C18.34 6.4 15.98 3.42 12.68 3.04C12.45 3.01 12.22 3 12 3C8.69 3 6.01 5.69 6.01 9C6.01 9.28 6.03 9.55 6.07 9.82C5.35 9.95 4.69 10.29 4.16 10.8C3.41 11.5 3 12.48 3 13.5V16.56C3 18.23 4.1 19.69 5.7 20.16L7.85 20.84C8.21 20.95 8.59 21.01 8.97 21.01C9.31 21.01 9.66 20.96 9.99 20.87L14.32 19.59C14.71 19.48 15.11 19.48 15.5 19.59L17.29 20.19C18.9 20.58 20.52 19.59 20.91 17.98C20.97 17.75 20.99 17.51 21 17.27V13.41C21 11.82 19.99 10.4 18.5 9.87ZM8.82 5.82C10.57 4.06 13.41 4.06 15.17 5.81C15.17 5.81 15.17 5.81 15.18 5.82C16.93 7.58 16.94 10.43 15.18 12.2L12.52 14.79C12.23 15.07 11.77 15.07 11.48 14.79L8.82 12.21C7.06 10.44 7.06 7.59 8.82 5.82ZM19.5 17.27C19.5 17.73 19.29 18.17 18.93 18.45C18.59 18.73 18.14 18.83 17.71 18.75L15.95 18.16C15.28 17.97 14.58 17.96 13.91 18.15L9.57 19.43C9.15 19.54 8.71 19.54 8.3 19.41L6.13 18.74C5.17 18.46 4.5 17.58 4.5 16.57V13.51C4.5 12.9 4.75 12.31 5.19 11.89C5.53 11.56 5.97 11.35 6.44 11.29C6.74 12.04 7.19 12.72 7.76 13.29L10.44 15.88C11.31 16.73 12.7 16.73 13.57 15.88L16.24 13.28C16.84 12.68 17.3 11.96 17.6 11.16L18 11.29C18.89 11.61 19.49 12.46 19.49 13.41V17.27H19.5Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_13083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu02Active);
export default __webpack_public_path__ + "static/media/ico-menu-02-active.c912b22e8a451fc9c5754fa29b937523.svg";
export { ForwardRef as ReactComponent };